import { Box } from '@mui/material';
import { useNavigate } from 'react-router';
import { ClickableCard } from './components/clickable-card';
import { Icon } from '@/components/shared/icon';

export const EmptyPlanCard = () => {
  const navigate = useNavigate();

  return (
    <Box width={{ xs: '100%', md: '50%' }}>
      <ClickableCard
        title="Crie um plano sob medida para você"
        description="Declare seus objetivos e a duração desejada para que nossa Inteligência Artificial recomende um plano estruturado com as atividades e conteúdos para desenvolver as suas habilidades."
        onClick={() => navigate(`/pdi/planos/novo`)}
        image={<Icon name="map" size={40} />}
      />
    </Box>
  );
};
